import PageLayout from "components/layout/PageLayout";
import SafetyStatsCard from "./SafetyStatsCard";

const { useTranslation } = require("react-i18next")

const SafetyStats = () => {

    const [t] = useTranslation(["global", "safety"])

    return (
        <PageLayout
            pageTitle={t("safety:menu.report")}
            bodyContent={<SafetyStatsCard/>}
        />
    );

}

export default SafetyStats